import React from 'react';
import axios from 'axios';
import { user_token } from '../../../services/Auth';

//import da API
import { organizer } from './../../../services/api';
let apiOrganizer = new organizer();

var token = localStorage.getItem(user_token);

export default class GetProfessional extends React.Component {
  state = {
    exam_possible_date: []
  }

  componentDidMount() {
    //axios.get(`http://api-convida.herokuapp.com/professional/${this.props.professional_id}`, {headers: {'x-access-token': token}})
    apiOrganizer.getProfessional(this.props.professional_id)
      .then(res => {
        const exam_possible_date = res.data;
        this.setState({ exam_possible_date });
      })
  }

  render() {
    return (
      <ul>
        { this.state.exam_possible_date.map(details => 
        <>
                <p id="PS-Title" >Nome do(a) Profissional da Saúde </p><p>{details.name}</p>
                <p id="PS-Title" >Possível Data do(a) Profissional da Saúde </p><p>{details.appointment_date}</p>
                <p id="PS-Title" >Notas </p><p>{details.notes}</p>
           
        </>)}
      </ul>
    )
  }
}